import React, {useState} from 'react';
import {TaskListWrapper, TaskListWrapperV2} from '../../../../my-work-tab/my-tasks-page/my_work_styled';
import TaskRow from './Task_row';
import TaskListHeader from './Task_row_header';
import Util from '../../../util/util';
import {hasFeatureFlag} from '../../../util/FeatureUtil';
export const TaskList = ({intl, enabledColumns, tasks, history, viewer, enableSort, stickyTopPosition, isInContainer, localSortKey, cy}) => {
	const [sortBy, setSortBy] = useState(localSortKey && Util.localStorageGetItem(localSortKey) ? JSON.parse(Util.localStorageGetItem(localSortKey)) : {column: null, ascending: false});
	Util.sortTasks(tasks, sortBy);

	const setSorting = sortBy => {
		if (enableSort) {
			setSortBy(sortBy);
			if (localSortKey) {
				Util.localStorageSetItem(localSortKey, JSON.stringify(sortBy));
			}
		}
	};

	// This is handling two versions of the TaskRow / TaskHeader for supporting the new Sub Task with a feature flag
	// PLEASE CLEAN THIS UP AFTERWARDS.
	const useTaskHierarchy =
		hasFeatureFlag('task_hierarchy', viewer.availableFeatureFlags) &&
		hasFeatureFlag('task_hierarchy_part2', viewer.availableFeatureFlags);
	const MyTaskListWrapper = useTaskHierarchy ? TaskListWrapperV2 : TaskListWrapper;

	return (
		<MyTaskListWrapper>
			<TaskListHeader intl={intl} enabledColumns={enabledColumns} sortBy={sortBy} onSortByChange={enableSort ? sortBy => setSorting(sortBy) : null} stickyTopPosition={stickyTopPosition} isInContainer={isInContainer} featureFlags={viewer.availableFeatureFlags}/>
			{tasks.map(task => (
				<TaskRow
					cy={cy}
					key={task.node.id}
					intl={intl}
					task={task.node}
					enabledColumns={enabledColumns}
					showTaskModal={taskId => Util.showTaskModal(taskId, history)}
					viewer={viewer} //TODO to removed, only used for Generic task context menu
				/>
			))}
		</MyTaskListWrapper>
	);
};
